"use strict";

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __exportStar = void 0 && (void 0).__exportStar || function (m, exports) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.writeToPath = exports.writeToString = exports.writeToBuffer = exports.writeToStream = exports.write = exports.format = exports.FormatterOptions = exports.CsvFormatterStream = void 0;
var util_1 = require("util");
var stream_1 = require("stream");
var fs = __importStar(require("fs"));
var FormatterOptions_1 = require("./FormatterOptions");
var CsvFormatterStream_1 = require("./CsvFormatterStream");
__exportStar(require("./types"), exports);
var CsvFormatterStream_2 = require("./CsvFormatterStream");
Object.defineProperty(exports, "CsvFormatterStream", {
  enumerable: true,
  get: function get() {
    return CsvFormatterStream_2.CsvFormatterStream;
  }
});
var FormatterOptions_2 = require("./FormatterOptions");
Object.defineProperty(exports, "FormatterOptions", {
  enumerable: true,
  get: function get() {
    return FormatterOptions_2.FormatterOptions;
  }
});
exports.format = function (options) {
  return new CsvFormatterStream_1.CsvFormatterStream(new FormatterOptions_1.FormatterOptions(options));
};
exports.write = function (rows, options) {
  var csvStream = exports.format(options);
  var promiseWrite = util_1.promisify(function (row, cb) {
    csvStream.write(row, undefined, cb);
  });
  rows.reduce(function (prev, row) {
    return prev.then(function () {
      return promiseWrite(row);
    });
  }, Promise.resolve()).then(function () {
    return csvStream.end();
  }).catch(function (err) {
    csvStream.emit('error', err);
  });
  return csvStream;
};
exports.writeToStream = function (ws, rows, options) {
  return exports.write(rows, options).pipe(ws);
};
exports.writeToBuffer = function (rows) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var buffers = [];
  var ws = new stream_1.Writable({
    write: function write(data, enc, writeCb) {
      buffers.push(data);
      writeCb();
    }
  });
  return new Promise(function (res, rej) {
    ws.on('error', rej).on('finish', function () {
      return res(Buffer.concat(buffers));
    });
    exports.write(rows, opts).pipe(ws);
  });
};
exports.writeToString = function (rows, options) {
  return exports.writeToBuffer(rows, options).then(function (buffer) {
    return buffer.toString();
  });
};
exports.writeToPath = function (path, rows, options) {
  var stream = fs.createWriteStream(path, {
    encoding: 'utf8'
  });
  return exports.write(rows, options).pipe(stream);
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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